<template>
  <HireComplianceGateStatusCompany
    v-if="hasCompanyCapabilities && !viewingAsSupplier"
    :compliances="compliances"
    :loading="loading"
    :hire-id="hireId"
  >
    <template v-if="$slots['hire-actions']" #hire-actions>
      <slot name="hire-actions"></slot>
    </template>
    <template v-if="$slots['worker-actions']" #worker-actions>
      <slot name="worker-actions"></slot>
    </template>
  </HireComplianceGateStatusCompany>
  <HireComplianceGateStatusRecruiter
    v-else-if="viewingAsSupplier"
    :compliances="compliances"
    :loading="loading"
    :hire-id="hireId"
  >
    <template v-if="$slots['recruiter-actions']" #recruiter-actions>
      <slot name="recruiter-actions"></slot>
    </template>
    <template v-if="$slots['worker-actions']" #worker-actions>
      <slot name="worker-actions"></slot>
    </template>
  </HireComplianceGateStatusRecruiter>
  <HireComplianceGateStatusWorker
    v-else
    :compliances="compliances"
    :loading="loading"
    :hire-id="hireId"
  >
    <template v-if="$slots['worker-actions']" #worker-actions>
      <slot name="worker-actions"></slot>
    </template>
  </HireComplianceGateStatusWorker>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useAccountCapabilities } from '@/composables/useAccountCapabilities'
import { useHireRecruiter } from '@/components/Hire/composables/useHireRecruiter'
import HireComplianceGateStatusCompany from '@/components/Hire/HirePageCompliance/HireComplianceGateStatusCompany.vue'
import HireComplianceGateStatusWorker from '@/components/Hire/HirePageCompliance/HireComplianceGateStatusWorker.vue'
import HireComplianceGateStatusRecruiter from '@/components/Hire/HirePageCompliance/HireComplianceGateStatusRecruiter.vue'

const props = defineProps<{
  compliances: any[]
  loading: boolean
  hireId: string
}>()

const { isWorker, isRecruiter, hasCompanyCapabilities, isCompany } = useAccountCapabilities()
const { viewerIsSupplier } = useHireRecruiter(props.hireId)
const viewingAsSupplier = computed(() => viewerIsSupplier.value || isRecruiter.value)
</script>
